import React from "react";
import { connect } from "react-redux";

// Components
import Searchbar from "../../utils/searchbar/Searchbar";
import SearchFaq from "./SearchFaq";

// State
import { addRoute } from "../../../store/actions/route";

class AdminFaq extends React.Component {
	constructor(props) {
		super(props);

		this.props.addRoute(this.props.match);
	}

	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search faq questions"}
					component={SearchFaq}
					searchEndpoint={"search/faq"}
					basePath={null}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminFaq);



// WEBPACK FOOTER //
// ./src/components/admin/faq/AdminFaq.js